import * as React from "react";
import { MultiComboBoxProps } from "../MultiComboBox";
import { SelectableOptionState } from "../SelectableOption";
import { addNonProdDisplayName } from "./helper";

interface ComboBoxPaperContextType {
    onSelectAll: (action: "clearAll" | "selectAll") => void;
    // `unknown` as type parameter is OK here as property itself does not depend on `ValueT`
    optionsFooter: MultiComboBoxProps<unknown>["optionsFooter"];
    PaperComponent: NonNullable<MultiComboBoxProps<unknown>["PaperComponent"]>;
    selectAllLabel: MultiComboBoxProps<unknown>["selectAllLabel"];
    selectAllState: SelectableOptionState;
}
type ComboBoxPaperContextHook = () => ComboBoxPaperContextType;

// Note: internal component needs no default, see https://reactjs.org/docs/context.html#reactcreatecontext
export const ComboBoxPaperContext = React.createContext<ComboBoxPaperContextType>((undefined as unknown) as ComboBoxPaperContextType);
addNonProdDisplayName(ComboBoxPaperContext, "ComboBoxPaperContext");

export const useComboBoxPaper: ComboBoxPaperContextHook = () => React.useContext(ComboBoxPaperContext);
